import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component } from 'intact-vue';
import template from './row.vdt';
import { bind } from '../utils';
import { isEqualObject } from '../utils';
import { useConfigContext } from '../config';
export var TableRow = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TableRow, _Component);
  function TableRow() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = TableRow.prototype;
  _proto.$update = function $update(lastVNode, nextVNode, parentDom, anchor, mountedQueue, force) {
    var lastProps = lastVNode.props;
    var nextProps = nextVNode.props;
    var isSame = true;
    var key;
    for (key in lastProps) {
      // ignore index
      if (key === 'index') continue;
      var lastValue = lastProps[key];
      var nextValue = nextProps[key];
      // deeply compare for offsetMap
      if (key === 'offsetMap' && isEqualObject(lastValue, nextValue)) {
        continue;
      }
      if (lastValue !== nextValue) {
        isSame = false;
        break;
      }
    }
    if (!isSame) {
      _Component.prototype.$update.call(this, lastVNode, nextVNode, parentDom, anchor, mountedQueue, force);
    } else {
      // should update index
      this.set(nextProps, {
        silent: true
      });
    }
  };
  _proto.onClick = function onClick(e) {
    if (e.target.tagName === 'INPUT') return;
    var _this$get = this.get(),
      index = _this$get.index,
      key = _this$get.key,
      data = _this$get.data,
      onClick = _this$get.onClick,
      disabled = _this$get.disabled;
    if (!disabled) {
      onClick(data, index, key);
    }
  };
  _proto.onChangeChecked = function onChangeChecked(v) {
    var _this$get2 = this.get(),
      index = _this$get2.index,
      key = _this$get2.key,
      onChangeChecked = _this$get2.onChangeChecked;
    onChangeChecked(index, v, key);
  };
  _proto.onClickArrow = function onClickArrow(e) {
    e.stopPropagation();
    var _this$get3 = this.get(),
      onToggleSpreadRow = _this$get3.onToggleSpreadRow,
      key = _this$get3.key;
    onToggleSpreadRow(key);
  };
  _proto.onMouseEnter = function onMouseEnter(e) {
    // for tooltip
    var mouseEnter = this.get('ev-mouseenter');
    mouseEnter && mouseEnter(e);
  };
  _proto.onMouseLeave = function onMouseLeave(e) {
    // for tooltip
    var mouseLeave = this.get('ev-mouseleave');
    mouseLeave && mouseLeave(e);
  };
  _proto.onRowDragStart = function onRowDragStart(e) {
    this.get('onRowDragStart')(e, this);
  };
  _proto.onRowDragOver = function onRowDragOver(e) {
    this.get('onRowDragOver')(e, this);
  };
  _proto.onRowDragEnd = function onRowDragEnd(e) {
    this.get('onRowDragEnd')(e, this);
  };
  _proto.beforeUnmount = function beforeUnmount() {
    this.get('onBeforeUnmount')(this.get('key'));
  };
  return TableRow;
}(Component);
TableRow.template = template;
__decorate([bind], TableRow.prototype, "onClick", null);
__decorate([bind], TableRow.prototype, "onChangeChecked", null);
__decorate([bind], TableRow.prototype, "onClickArrow", null);
__decorate([bind], TableRow.prototype, "onMouseEnter", null);
__decorate([bind], TableRow.prototype, "onMouseLeave", null);
__decorate([bind], TableRow.prototype, "onRowDragStart", null);
__decorate([bind], TableRow.prototype, "onRowDragOver", null);
__decorate([bind], TableRow.prototype, "onRowDragEnd", null);